export default "__VITE_ASSET__3nvE$hMl__"